import { cn } from '@/utils/utils.ts';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-primary/10 bg-[#F3F4F6]',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
